import React, { useEffect, useState } from 'react';
import '../../index.css';
import { useAuth } from '../../context/authContext';
import { Card, CardContent, CardHeader } from '../ui/card';
import { getPaymentLogs } from '../../services/payment.service';
import { useResolvedPaymentParams } from '../../hooks/useResolvedPaymentParams';
import { ScrollText } from 'lucide-react';
import { ListCardSkeleton } from '../ui/card-skeletons';
import AsyncContent from '../ui/AsyncContent';

const PaymentAuthLogs = ({ updatePage }) => {
    const { authenticated, user } = useAuth();
    const [paymentLogs, setPaymentLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const { resolvedPaymentId, resolvedOrgId } = useResolvedPaymentParams();

    useEffect(() => {
        const fetchPaymentLogs = async () => {
            setLoading(true);
            const logsResponse = await getPaymentLogs(user.token, resolvedPaymentId, resolvedOrgId);
            if (logsResponse && logsResponse.status === 200) {
                setPaymentLogs(logsResponse.data.data);
            }
            setLoading(false);
        };
        fetchPaymentLogs();
    }, [resolvedPaymentId, resolvedOrgId, user.token, updatePage]);

    return (
        <div className="w-full h-full">
            <AsyncContent
                loading={loading}
                skeleton={<ListCardSkeleton titleWidth="w-40" lines={5} />}
            >
                <Card className="h-full flex flex-col overflow-hidden">
                    <CardHeader className="border-b border-slate-100 bg-slate-50/50 pb-4">
                        <div className="flex items-center gap-3">
                            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-100 border border-slate-200">
                                <ScrollText className="h-4 w-4 text-slate-500" />
                            </span>
                            <h3 className="my-0">Payment logs</h3>
                        </div>
                    </CardHeader>
                    <CardContent className="flex-1 pt-4">
                        {authenticated && paymentLogs.length > 0 ? (
                            <div className="flex flex-col">
                                {paymentLogs.map((log, index) => (
                                    <div
                                        key={index}
                                        className="py-3 border-b border-slate-100 last:border-0 text-sm text-slate-600 leading-relaxed"
                                    >
                                        {log.message}
                                    </div>
                                ))}
                            </div>
                        ) : authenticated ? (
                            <p className="text-sm text-slate-400 m-0">No authorisation activity recorded yet.</p>
                        ) : (
                            <div className="blur select-none">
                                <p>Details cannot be displayed.</p>
                            </div>
                        )}
                    </CardContent>
                </Card>
            </AsyncContent>
        </div>
    );
};

export default PaymentAuthLogs;
